import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import {HomeHeader, Banner, BannerButton} from "../utils"
import {Link} from "gatsby"
import img from "../images/bcg/homeBcg.jpeg"
import QuickInfo from "../components/HomePageComponents/QuickInfo"
import Gallery from "../components/HomePageComponents/Gallery"
import ContactInfo from "../components/HomePageComponents/ContactInfo"
import Menu from "../components/HomePageComponents/Menu"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <HomeHeader img={img}>
      <Banner title="Burger Times" subtitle="3 Rue Saint-Nicolas, Bordeaux, Nouvelle-Aquitaine 33800">
      <Link to="/menu/" style={{ textDecoration: 'none' }}>
        <BannerButton style={{margin: '2rem auto'}} >Menu</BannerButton>
      </Link>
      </Banner>
    </HomeHeader>
    <QuickInfo/>
    <Gallery />
    <Menu/>
    <ContactInfo/>
  </Layout>
)

export default IndexPage